import { Tooltip } from '@design-system/components/tooltip/tooltip';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faInfoCircle } from '@fortawesome/pro-solid-svg-icons';

import { CONSUMER_TAB_TOOLTIP_COPY } from './ConsumerTabCell';
import * as styles from './ProgramsListHeader.css';

type ProgramsListHeaderProps = {
  reorderMode?: boolean;
};

export const ProgramsListHeader = ({
  reorderMode = false,
}: ProgramsListHeaderProps) => {
  return (
    <div
      className={styles.header({ reorderMode })}
      data-testid="programs-list-header"
    >
      <span className={styles.label}>Name</span>
      <span className={styles.label}>Status</span>
      <span className={styles.label}>Offers</span>
      <span className={styles.consumerTabLabel}>
        Consumer Tab
        <Tooltip arrow variant="dark" title={CONSUMER_TAB_TOOLTIP_COPY}>
          <span data-testid="programs-consumer-tab-tooltip">
            <FontAwesomeIcon
              icon={faInfoCircle}
              className={styles.tooltipIcon}
            />
          </span>
        </Tooltip>
      </span>
      <span className={styles.labelCenter}>Rating</span>
      <span className={styles.labelBegins}>Begins</span>
      <span className={styles.labelCompletion}>Completion</span>
      <span className={styles.labelComments}>Comments</span>
      <span className={styles.labelStatsPlaceholder} />
      <span />
      <span />
      {reorderMode ? <span /> : null}
    </div>
  );
};
